import axios from "axios";
import { serverUrl } from "../../components/Helpers/Config";
import { tokenAuthorize } from "../../components/Helpers/Common";

export const SHOWCASE_LOADED = "SHOWCASE_LOADED";
export const SHOWCASE_LOADING = "SHOWCASE_LOADING";
export const SHOWCASE_CREATED = "SHOWCASE_CREATED";
export const SHOWCASE_DELETED = "SHOWCASE_DELETED";
export const SHOWCASE_PROCESS_LOADING = "SHOWCASE_PROCESS_LOADING";
export const SHOWCASE_PROCESS_FAILED = "SHOWCASE_PROCESS_FAILED";

export const SHOWCASE_DETAILS_LOADED = "SHOWCASE_DETAILS_LOADED";
export const GET_DPSTATISTICS_LOADED = "GET_DPSTATISTICS_LOADED";

export const SHOWCASE_POST_LOADING = "SHOWCASE_POST_LOADING";
export const SHOWCASE_POST_LOADED = "SHOWCASE_POST_LOADED";
export const SHOWCASE_POST_DELETED = "SHOWCASE_POST_DELETED";
export const SHOWCASE_POST_PROCESS_LOADING = "SHOWCASE_POST_PROCESS_LOADING";
export const SHOWCASE_POST_PROCESS_FAILED = "SHOWCASE_POST_PROCESS_FAILED";

export const SHOWCASE_ACCESS_UPDATED = "SHOWCASE_ACCESS_UPDATED";

export const MY_POST_LOADED = "MY_POST_LOADED";
export const MY_POST_PROCESS_FAILED = "MY_POST_PROCESS_FAILED";

export const ADD_SHOWCASE_POST_PROCESS_LOADING =
  "ADD_SHOWCASE_POST_PROCESS_LOADING";
export const SHOWCASE_POST_ADDED = "SHOWCASE_POST_ADDED";
export const ADD_SHOWCASE_POST_PROCESS_FAILED =
  "ADD_SHOWCASE_POST_PROCESS_FAILED";

export const SHOWCASE_EDITED = "SHOWCASE_EDITED";
export const LIKE_SHOWCASE_POST = "LIKE_SHOWCASE_POST";

export const GET_SHOWCASE_CARDS = "GET_SHOWCASE_CARDS";

export const getShowcases = () => {
  return (dispatch, getState) => {
    return axios
      .get(serverUrl.Showcase)
      .then((resp) => {
        if (resp.status === 200) {
          let showcases = resp.data;

          dispatch({
            type: SHOWCASE_LOADED,
            payload: { showcases },
          });
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        dispatch({
          type: SHOWCASE_LOADED,
          errors: [err],
        });
      });
  };
};

export const getShowcaseDetails = () => {
  return (dispatch) => {
    return axios.get(serverUrl.ShowcaseDetails).then((resp) => {
      if (resp.status === 200) {
        let showcaseDetails = resp.data;

        dispatch({
          type: SHOWCASE_DETAILS_LOADED,
          payload: { ...showcaseDetails },
        });
      }
    });
  };
};

export const createShowcase = (showcaseName, profile_id, sort_order) => {
  return (dispatch, getState) => {
    dispatch({ type: SHOWCASE_PROCESS_LOADING });

    return axios
      .post(serverUrl.Showcase, {
        showcase_name: showcaseName,
        profile_id: profile_id,
        sort_order: sort_order,
      })
      .then((resp) => {
        if (resp.status === 201) {
          dispatch({ type: SHOWCASE_CREATED });
          dispatch(getShowcases());
        } else {
          dispatch({ type: SHOWCASE_PROCESS_FAILED });
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        dispatch({
          type: SHOWCASE_PROCESS_FAILED,
          errors: [err],
        });
      });
  };
};

export const editShowcase = (showcaseName, showcaseId) => {
  return (dispatch, getState) => {
    dispatch({ type: SHOWCASE_PROCESS_LOADING });
    return axios
      .put(serverUrl.Showcase2 + "/" + showcaseId, {
        showcase_name: showcaseName,
        showcase_id: showcaseId,
      })
      .then((resp) => {
        if (resp.status === 201) {
          dispatch({ type: SHOWCASE_EDITED });
          dispatch(getShowcases());
        } else {
          dispatch({ type: SHOWCASE_PROCESS_FAILED });
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        dispatch({
          type: SHOWCASE_PROCESS_FAILED,
          errors: [err],
        });
      });
  };
};

export const deleteShowcase = (showcaseId) => {
  return (dispatch) => {
    dispatch({ type: SHOWCASE_PROCESS_LOADING });

    return axios
      .delete(serverUrl.Showcase + "/" + showcaseId)
      .then((resp) => {
        if (resp.status === 200) {
          dispatch({ type: SHOWCASE_DELETED });
          dispatch(getShowcases());
        } else {
          dispatch({ type: SHOWCASE_PROCESS_FAILED });
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        dispatch({
          type: SHOWCASE_PROCESS_FAILED,
          errors: [err],
        });

        throw err;
      });
  };
};

export const updateShowcasePublicAccess = (showcaseId, newPublicAccess) => {
  return (dispatch, getState) => {
    dispatch({ type: SHOWCASE_PROCESS_LOADING });

    return axios
      .patch(serverUrl.ShowcaseAccess, {
        showcase_id: showcaseId,
        public_access: newPublicAccess,
      })
      .then((resp) => {
        if (resp.status === 201) {
          dispatch({ type: SHOWCASE_ACCESS_UPDATED });
          dispatch(getShowcases());
          dispatch(getDPStatistics());
        } else {
          dispatch({ type: SHOWCASE_PROCESS_FAILED });
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        dispatch({
          type: SHOWCASE_PROCESS_FAILED,
          errors: [err],
        });
      });
  };
};

export const getMyPosts = () => {
  return (dispatch, getState) => {
    return axios
      .get(serverUrl.Post)
      .then((resp) => {
        if (resp.status === 200) {
          let myPosts = resp.data.results;

          dispatch({
            type: MY_POST_LOADED,
            data: {
              myPosts,
            },
          });
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        dispatch({
          type: MY_POST_PROCESS_FAILED,
          errors: [err],
        });
      });
  };
};

export const likeShowcasePost = (postId) => {
  return (dispatch) => {
    dispatch({
      type: LIKE_SHOWCASE_POST,
      payload: postId,
    });
  };
};

export const addShowcasePost = (showcaseId, reflectionId, length) => {
  return (dispatch) => {
    dispatch({ type: ADD_SHOWCASE_POST_PROCESS_LOADING });

    return axios
      .post(serverUrl.ShowcasePost, {
        showcase_id: showcaseId,
        reflection_id: reflectionId,
        order: length + 1,
      })
      .then((resp) => {
        if (resp.status === 201) {
          dispatch({ type: SHOWCASE_POST_ADDED });
          // dispatch(getShowcasePost(showcaseId,0,10))
          // dispatch(getAboutPost(showcaseId,0,10))
          // dispatch(getStatusPost(showcaseId,0,10))
        } else {
          dispatch({ type: SHOWCASE_PROCESS_FAILED });
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        dispatch({
          type: ADD_SHOWCASE_POST_PROCESS_FAILED,
          errors: [err],
        });
      });
  };
};

export const deleteShowcasePost = (showcasePostId) => {
  return (dispatch) => {
    return axios
      .delete(serverUrl.ShowcasePost + "/" + showcasePostId)
      .then((resp) => {
        if (resp.status === 200) {
          dispatch({ type: SHOWCASE_POST_DELETED });
          dispatch(getShowcases());
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        dispatch({
          type: SHOWCASE_POST_PROCESS_FAILED,
          errors: [err],
        });
      });
  };
};

export const getDPStatistics = () => {
  return (dispatch) => {
    return axios.get(serverUrl.GetDPStatistics).then((resp) => {
      if (resp.status === 200) {
        let dpStatistics = resp.data;
        dispatch({
          type: GET_DPSTATISTICS_LOADED,
          payload: { ...dpStatistics },
        });
      }
    });
  };
};
export const getShowcaseCards = () => {
  return (dispatch) => {
    return axios.get(serverUrl.ShowcaseCards).then((resp) => {
      if (resp.status === 200) {
        let showcaseCards = resp.data;
        dispatch({
          type: GET_SHOWCASE_CARDS,
          payload: { ...showcaseCards },
        });
      }
    });
  };
};
